import { Paragraph } from "../types/models/Paragraph";
import { RuleInstance } from "../types/models/RuleInstance";
import { getParagraphMetadata, splitTaxonomy } from "./RuleUtil";

export const getModuleNameFromTaxonomy = (taxonomy: string) => {
  const splitName = splitTaxonomy(taxonomy);
  if (!splitName) {
    return taxonomy;
  } else if (splitName?.header.includes("#")) {
    return splitName.header.split("#")[1];
  } else {
    return splitName.header;
  }
};

export const taxonomyMatchesModule = (taxonomy: string | null | undefined, moduleName: string): boolean => {
  if (!taxonomy) return false;
  const part = taxonomy.split(";")[0];
  return part.includes("#") ? part.split("#")[1] === moduleName : part === moduleName;
};

export const getTaxonomyContentSection = (taxonomy: string | null | undefined): string => {
  if (!taxonomy) return "";
  return taxonomy.split(";")[1]?.trim() ?? "";
};

export const getContentNameFromTaxonomy = (
  taxonomy: string | undefined,
  contentDisplayName: string
) => {
  if (taxonomy?.includes(";")) {
    return `${taxonomy.split(";")[1].trim()} > ${contentDisplayName}`;
  }
  return contentDisplayName;
};

export const getParagraphIdFromIndex = (ruleContent: RuleInstance, selectedParagraphIndex: number): string | undefined => {
  let paragraphId = undefined;
    if(selectedParagraphIndex === 0) {
      // For the first paragraph, we can use the RuleId (the same as the HTML file name), since some rules don’t include a paragraph ID in the metadata.
      paragraphId = ruleContent.RuleId;
    } else {
      const metadata = getParagraphMetadata(ruleContent.Paragraphs[selectedParagraphIndex].Metadata ?? "");
      paragraphId = (metadata?.id?.length ?? 0) > 0 ? metadata?.id[0] : undefined;
    }
  return paragraphId;
}

export const filterOutComponentForkParagraphs = (paragraphs: Paragraph[]): Paragraph[] => {
  return paragraphs.filter(paragraph => {
    const metadata = getParagraphMetadata(paragraph.Metadata ?? "");
    if (metadata?.["resource-type"]?.length && metadata["resource-type"][0] === "component fork") {
      return false;
    }
    return true; 
  });
};
